import Vue from "vue";
import commaNumber from "comma-number";
const priceCommaFormat = commaNumber.bindWith(",", ".");

Vue.filter("formattedPrice", function (value) {
    if (value === "-") {
        return value;
    }

    if (value) {
        const twoDecimal = Math.round((value + Number.EPSILON) * 100) / 100;
        return priceCommaFormat(twoDecimal);
    }

    return value;
});

Vue.filter("toFixed2", function (value) {
    return value.toFixed(2);
})

Vue.filter("nagativeNumber", function (value) {
    if (value == null) {
        return null;
    }
    if(value == 0){
        return value;
    }
    return "-" + value;
});

Vue.filter("positiveNumber", function (value) {
    if (value == null) {
        return null;
    }
    if(value == 0){
        return value;
    }
    if(value == "-"){
        return value;
    }
    if(value == "loading..."){
        return value;
    }
    return "+" + value;
});
